import { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Image,
  Box,
  Text,
} from "@chakra-ui/react";
import {
  NavButtonHolder,
  NavButtonDiv2,
  NavButtonLeft,
  NavButton,
  NavButtonRight,
} from "../ListingCard/ListingCard2point0Styles";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import styles from "./SlideshowModal.module.css";

interface SlideshowModalProps {
  modalClose: () => void;
  modalOpen: boolean;
  images: string[];
  imgId: number;
}

const SlideshowModal = ({
  modalClose,
  modalOpen,
  images,
  imgId,
}: SlideshowModalProps) => {
  const [activeImg, setActiveImg] = useState(imgId);
  const [translateValue, setTranslateValue] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const touchEndX = useRef<number | null>(null);

  useEffect(() => {
    setActiveImg(imgId);
  }, [imgId]);

  const minSwipeDistance = 50;

  const onTouchStart = (e: React.TouchEvent) => {
    touchEndX.current = null;
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const onTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const onTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    
    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && activeImg < images.length - 1) {
      // Swipe left = next image
      if (activeImg >= 2 && activeImg < images.length - 3) {
        setTranslateValue(translateValue - 11);
      }
      setActiveImg(activeImg + 1);
    }
    
    if (isRightSwipe && activeImg > 0) {
      // Swipe right = previous image
      if (activeImg >= 3 && activeImg < images.length - 2) {
        setTranslateValue(translateValue + 11);
      }
      setActiveImg(activeImg - 1);
    }
  };

  return (
    <>
      <Modal isOpen={modalOpen} onClose={modalClose} isCentered>
        <ModalOverlay background={"black"} opacity={0.93} />
        <ModalContent className={styles.modalContainer}>
          <Box className={styles.counterContainer}>
            <Text fontFamily={"'Jarkarta',sans-serif"} color="white">
              {activeImg + 1} / {images.length}
            </Text>
          </Box>
          <Box 
            display={"block"}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            style={{ touchAction: 'pan-x' }}
          >
            <Image
              src={images[activeImg]}
              maxH="85vh"
              maxW="100%"
              mx="auto"
              objectFit="contain"
            />
          </Box>
          {images?.length >= 2 && (
            <NavButtonHolder>
              <NavButtonDiv2>
                {activeImg !== 0 && (
                  <NavButtonLeft
                    onClick={() => {
                      if (activeImg >= 3 && activeImg < images?.length - 2) {
                        setTranslateValue(translateValue + 11);
                      }
                      setActiveImg(activeImg - 1);
                    }}
                  >
                    <NavButton size="40px">
                      <span>
                        <MdChevronLeft size="25px" />
                      </span>
                    </NavButton>
                  </NavButtonLeft>
                )}

                {activeImg !== images?.length - 1 && (
                  <NavButtonRight
                    onClick={() => {
                      if (activeImg >= 2 && activeImg < images?.length - 3) {
                        setTranslateValue(translateValue - 11);
                      }
                      setActiveImg(activeImg + 1);
                    }}
                  >
                    <NavButton size="40px">
                      <span>
                        <MdChevronRight size="25px" />
                      </span>
                    </NavButton>
                  </NavButtonRight>
                )}
              </NavButtonDiv2>
            </NavButtonHolder>
          )}
          <ModalCloseButton color={"white"} />
        </ModalContent>
      </Modal>
    </>
  );
};

export default SlideshowModal;
